import { render } from "./Order.vue?vue&type=template&id=6c7a9ef0&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=6c7a9ef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c7a9ef0"

export default script